export default {
  title: {
    pt: 'Processando',
    en: 'Processing'
  },
  description: {
    pt: 'Não feche essa aba.',
    en: 'Do not close this tab.'
  }
}
